define('lq/events/actions/executePlugin',[
    'lq/events/actions/eventAction',
    'lq/fileUpload'
], function (EventAction, FileUpload) {
    'use strict';

    function ExecutePlugin(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ExecutePlugin, EventAction);

    ExecutePlugin.typeName = 'ExecutePlugin';

    ExecutePlugin.prototype.getBatchType = function () {
        if (this.eventData.doNotBatch) {
            return EventAction.DO_NOT_BATCH;
        }
        return EventAction.COMMAND_BATCH;
    };

    ExecutePlugin.prototype.createEventActionRequest = function () {
        var self = this;

        var eventActionRequest = {
            eventActionType: "ExecutePlugin",
            morphId: self.eventData.command,
            files: []
        };

        if (self.eventData.fileUploads && self.eventData.fileUploads.length > 0) {
            self.piping.busyIndicator.hide();

            return function (continuation) {
                self.uploadFile(0, eventActionRequest, continuation);
            };
        }
        else {
            return eventActionRequest;
        }
    };

    ExecutePlugin.prototype.uploadFile = function (fileUploadIndex, eventActionRequest, continuation) {
        var self = this;

        if (fileUploadIndex >= self.eventData.fileUploads.length) {
            self.piping.busyIndicator.show();
            continuation(eventActionRequest);
            return;
        }

        var fileUpload = self.eventData.fileUploads[fileUploadIndex];

        var uploader = new FileUpload({
            accept: fileUpload.accept,
            multiple: fileUpload.multiple,
            onInvalidFileExtension: function (filename, extensions) {
                alert(filename + ' has invalid extension. Only ' + extensions + ' files are allowed.')
            },
            onFilesSelected: function (files) {
                const addFile = function (fileIndex) {
                    if (fileIndex < files.length) {
                        const file = files[fileIndex];
                        const reader = new FileReader();

                        reader.onload = function(evt) {
                            const data = evt.target.result;

                            eventActionRequest.files.push({
                                name: fileUpload.name,
                                filename: file.name,
                                data: data
                            });

                            addFile(fileIndex + 1);
                        };

                        reader.readAsDataURL(file);
                    }
                    else {
                        self.uploadFile(fileUploadIndex + 1, eventActionRequest, continuation);
                    }
                }

                addFile(0);
            }
        });

        uploader.do();
    };

    return ExecutePlugin;
});
